import { render, staticRenderFns } from "./reLoginAlert.vue?vue&type=template&id=4ab037a6&scoped=true&"
import script from "./reLoginAlert.vue?vue&type=script&lang=js&"
export * from "./reLoginAlert.vue?vue&type=script&lang=js&"
import style0 from "./reLoginAlert.vue?vue&type=style&index=0&id=4ab037a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab037a6",
  null
  
)

export default component.exports